import React, { Component } from 'react';
import { Menu } from 'antd';
import Auth from './Auth';

export default class AuthMenuItem extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        if (this.props.onValidateEnd) {
            this.props.onValidateEnd(this.allowAccess);
        }
    }
    render() {
        let authcode = this.props.authcode;
        if (!Auth.validate(authcode)) {
            this.allowAccess = false;
            switch (this.props.authmode) {
                case 'disabled': return <Menu.Item {...this.props} disabled title="你没有权限使用该功能！">
                </Menu.Item>
                    break;
                case 'visible':
                default: return null;
            }
        }
        this.allowAccess = true;
        return <Menu.Item {...this.props}>
        </Menu.Item>
    }
}